import { render } from "./checkUserRightModel.vue?vue&type=template&id=51f40769"
import script from "./checkUserRightModel.vue?vue&type=script&lang=js"
export * from "./checkUserRightModel.vue?vue&type=script&lang=js"

import "./checkUserRightModel.vue?vue&type=style&index=0&id=51f40769&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__